import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { desktopCSS } from '@measures/responsive'
import useHasInvertedColors from '@hooks/useHasInvertedColors'
import useHasBlurryBackground from '@hooks/useHasBlurryBackground'

export interface CatchwordProps {
  children?: ReactNode
  hasPlusLogo: boolean
  hasLoudspeaker: boolean
}

export interface InvertedColorsStyledProps {
  hasInvertedColors: boolean
}

interface RelatedItemsDesktopStyledProps {
  isInRelatedItemsDesktop: boolean
}

export type StyledCatchwordProps = Pick<
  CatchwordProps,
  'hasPlusLogo' | 'hasLoudspeaker'
> &
  InvertedColorsStyledProps &
  RelatedItemsDesktopStyledProps

const StyledCatchword = styled.div<StyledCatchwordProps>`
  ${({
    theme: {
      spacing: { spacing4, spacing12 },
      colors: { textBrand, staticRed400, staticNeutral400 },
      typography: {
        subheads: {
          small1: { bundledCSS: small1SubheadingCSS },
        },
      },
      utils: { ellipsis },
    },
    hasPlusLogo,
    hasInvertedColors,
    hasLoudspeaker,
    isInRelatedItemsDesktop,
  }) => {
    const color = hasInvertedColors ? staticRed400 : textBrand
    return css`
      ${small1SubheadingCSS};
      color: ${color};
      ${hasLoudspeaker &&
      css`
        margin-top: ${spacing12};
      `}
      margin-bottom: ${spacing4};
      ${ellipsis('100%', 1)};
      display: block;
      ${desktopCSS(css`
        ${isInRelatedItemsDesktop &&
        css`
          color: ${staticNeutral400};
        `};
        ${ellipsis('100%', 2)};
        ${hasPlusLogo &&
        css`
          line-height: 1.3;
        `};
      `)}
    `
  }}
`

const Catchword: FunctionComponent<CatchwordProps> = ({
  children,
  hasPlusLogo,
  hasLoudspeaker,
}) => {
  const hasInvertedColors = useHasInvertedColors()
  const isInRelatedItemsDesktop = useHasBlurryBackground()

  return (
    <StyledCatchword
      isInRelatedItemsDesktop={isInRelatedItemsDesktop}
      hasPlusLogo={hasPlusLogo}
      hasLoudspeaker={hasLoudspeaker}
      hasInvertedColors={hasInvertedColors}>
      {children}
    </StyledCatchword>
  )
}

export default Catchword
